module.exports = __webpack_public_path__ + "static/media/sort-alpha-down-alt.0c5932d0.svg";